import type { Devo } from "~/hooks/usePlayerStore";
import { getActiveEpisodePlaybackLayout } from "~/lib/episode.utils";

export function getCurrentEpisodePlaybackLayout(devo: Devo, usingFallbackSequence: boolean) {
  return getActiveEpisodePlaybackLayout(devo, usingFallbackSequence);
}
